<script>
  export let cases_since_trump_2;
  export let count;  // pre-computed count
</script>

<div class="feltron">{count.toLocaleString()}</div>
<div class="feltron-subtext"> {cases_since_trump_2 }</div>
<style>
.feltron {
    font-family: var(--fonts-hed);
    font-size: 6rem;
    font-weight: bold;
    line-height: var(--line-height-2);
    color: var(--blue-60);
}
.feltron-subtext {
    font-family: var(--fonts-sans);
}
</style>
